import { IconProps } from './type';

export const ICLink: React.FC<IconProps> = ({
    stroke = '#46485C',
    width = 24,
    height = 24,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.379 10.1906L5.14554 12.424C4.31141 13.2582 3.83173 14.3931 3.8405 15.5859C3.84926 16.7787 4.31844 17.9206 5.19216 18.7674C6.03884 19.6411 7.18097 20.1103 8.37359 20.119C9.59342 20.128 10.7015 19.6753 11.5357 18.8412L13.7692 16.6077M16.622 13.8095L18.8554 11.576C19.6896 10.7419 20.1692 9.60693 20.1605 8.41412C20.1517 7.2213 19.6825 6.07942 18.8088 5.23268C17.9623 4.3862 16.8204 3.91699 15.6276 3.90822C14.4348 3.89946 13.2997 4.35191 12.4655 5.18607L10.232 7.41952M8.61359 15.3272L15.314 8.62683"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
